"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDoubleSidedFrontSide = exports.isDoubleSidedBackSide = exports.getDoubleSidedFrontSide = exports.getDoubleSidedBackSide = void 0;
var isDoubleSidedFrontSide = exports.isDoubleSidedFrontSide = function isDoubleSidedFrontSide(side) {
  return side === '1';
};
var isDoubleSidedBackSide = exports.isDoubleSidedBackSide = function isDoubleSidedBackSide(side) {
  return side === '-1';
};
var getDoubleSidedBackSide = exports.getDoubleSidedBackSide = function getDoubleSidedBackSide() {
  return '-1';
};
var getDoubleSidedFrontSide = exports.getDoubleSidedFrontSide = function getDoubleSidedFrontSide() {
  return '1';
};